module.exports = __webpack_public_path__ + "img/1.e81a6fbb.jpg";